var _ellipse, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 208,
    viewBox: "0 0 284 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 200.688,
    rx: 141.628,
    ry: 7.31229,
    fill: "url(#paint0_radial_102_53)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.662 193.583H71.1524C69.0609 193.583 67.3654 195.277 67.3654 197.366C67.3654 199.456 69.0609 201.15 71.1524 201.15H110.662C112.753 201.15 114.449 199.456 114.449 197.366C114.449 195.277 112.753 193.583 110.662 193.583Z",
    fill: "#204F82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.917 193.583H171.408C169.316 193.583 167.621 195.277 167.621 197.366C167.621 199.456 169.316 201.15 171.408 201.15H210.917C213.009 201.15 214.704 199.456 214.704 197.366C214.704 195.277 213.009 193.583 210.917 193.583Z",
    fill: "#204F82"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M210.917 193.583H171.408C169.316 193.583 167.621 195.277 167.621 197.366C167.621 199.456 169.316 201.15 171.408 201.15H210.917C213.009 201.15 214.704 199.456 214.704 197.366C214.704 195.277 213.009 193.583 210.917 193.583Z",
    fill: "url(#paint1_linear_102_53)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M110.662 193.583H71.1524C69.0609 193.583 67.3654 195.277 67.3654 197.366C67.3654 199.456 69.0609 201.15 71.1524 201.15H110.662C112.753 201.15 114.449 199.456 114.449 197.366C114.449 195.277 112.753 193.583 110.662 193.583Z",
    fill: "url(#paint2_linear_102_53)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.879 0H71.7913C52.6617 0 37.1541 15.5076 37.1541 34.6372V160.486C37.1541 179.615 52.6617 195.123 71.7913 195.123H211.879C231.009 195.123 246.517 179.615 246.517 160.486V34.6372C246.517 15.5076 231.009 0 211.879 0Z",
    fill: "url(#paint3_linear_102_53)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_102_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.162 180.429H87.5242C78.3757 180.419 69.6048 176.78 63.1358 170.311C56.6668 163.842 53.028 155.071 53.0179 145.923V49.1848C53.0281 40.037 56.667 31.2669 63.1362 24.7992C69.6054 18.3314 78.3764 14.6944 87.5242 14.6862H196.162C205.308 14.6964 214.077 18.3343 220.545 24.8019C227.012 31.2694 230.65 40.0384 230.66 49.1848V145.938C230.646 155.083 227.007 163.848 220.54 170.314C214.073 176.779 205.306 180.417 196.162 180.429V180.429ZM87.5242 17.6188C79.1575 17.629 71.1365 20.9572 65.2204 26.8733C59.3042 32.7894 55.9761 40.8105 55.9659 49.1771V145.93C55.9659 150.075 56.7822 154.178 58.3681 158.007C59.9541 161.836 62.2786 165.315 65.2091 168.245C68.1395 171.176 71.6185 173.5 75.4474 175.086C79.2762 176.672 83.3799 177.489 87.5242 177.489H196.162C204.528 177.478 212.549 174.15 218.466 168.234C224.382 162.318 227.71 154.297 227.72 145.93V49.1848C227.708 40.8188 224.379 32.799 218.463 26.8833C212.548 20.9676 204.528 17.6388 196.162 17.6265L87.5242 17.6188Z",
    fill: "url(#paint4_linear_102_53)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3915 168.252C92.4514 168.252 98.9853 161.718 98.9853 153.658C98.9853 145.598 92.4514 139.064 84.3915 139.064C76.3316 139.064 69.7977 145.598 69.7977 153.658C69.7977 161.718 76.3316 168.252 84.3915 168.252Z",
    fill: "#204F82"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M85.2151 168.252C93.2751 168.252 99.8089 161.718 99.8089 153.658C99.8089 145.598 93.2751 139.064 85.2151 139.064C77.1552 139.064 70.6213 145.598 70.6213 153.658C70.6213 161.718 77.1552 168.252 85.2151 168.252Z",
    fill: "url(#paint5_linear_102_53)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.279 168.252C207.339 168.252 213.873 161.718 213.873 153.658C213.873 145.598 207.339 139.064 199.279 139.064C191.219 139.064 184.685 145.598 184.685 153.658C184.685 161.718 191.219 168.252 199.279 168.252Z",
    fill: "#204F82"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M198.178 168.252C206.238 168.252 212.772 161.718 212.772 153.658C212.772 145.598 206.238 139.064 198.178 139.064C190.119 139.064 183.585 145.598 183.585 153.658C183.585 161.718 190.119 168.252 198.178 168.252Z",
    fill: "url(#paint6_linear_102_53)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6498 61.708C55.2969 61.708 55.9175 61.9651 56.3751 62.4226C56.8327 62.8802 57.0898 63.501 57.0898 64.1481V84.5147C57.0898 84.7361 57.0462 84.9552 56.9615 85.1597C56.8768 85.3642 56.7526 85.5502 56.5961 85.7067C56.4395 85.8632 56.2537 85.9873 56.0492 86.072C55.8447 86.1567 55.6255 86.2004 55.4041 86.2004H53.8647C53.6433 86.2004 53.4241 86.1567 53.2196 86.072C53.0151 85.9873 52.8293 85.8632 52.6727 85.7067C52.5162 85.5502 52.3921 85.3642 52.3073 85.1597C52.2226 84.9552 52.179 84.7361 52.179 84.5147V64.1481C52.179 63.8251 52.2431 63.5053 52.3677 63.2072C52.4922 62.9091 52.6747 62.6387 52.9045 62.4117C53.1343 62.1848 53.407 62.0056 53.7066 61.8848C54.0062 61.764 54.3268 61.7039 54.6498 61.708V61.708Z",
    fill: "url(#paint7_linear_102_53)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6498 108.922C55.2969 108.922 55.9175 109.179 56.3751 109.637C56.8327 110.095 57.0898 110.715 57.0898 111.362V131.729C57.0898 132.176 56.9122 132.605 56.5961 132.921C56.2799 133.237 55.8512 133.415 55.4041 133.415H53.8647C53.4176 133.415 52.9889 133.237 52.6727 132.921C52.3566 132.605 52.179 132.176 52.179 131.729V111.362C52.179 110.715 52.4361 110.095 52.8936 109.637C53.3512 109.179 53.9719 108.922 54.619 108.922H54.6498Z",
    fill: "url(#paint8_linear_102_53)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_102_53)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.835 145.899C168.362 145.899 189.866 124.395 189.866 97.8691C189.866 71.3428 168.362 49.839 141.835 49.839C115.309 49.839 93.8051 71.3428 93.8051 97.8691C93.8051 124.395 115.309 145.899 141.835 145.899Z",
    fill: "#055CAA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.835 145.899C168.362 145.899 189.866 124.395 189.866 97.8691C189.866 71.3428 168.362 49.839 141.835 49.839C115.309 49.839 93.8051 71.3428 93.8051 97.8691C93.8051 124.395 115.309 145.899 141.835 145.899Z",
    fill: "url(#paint9_linear_102_53)",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_102_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.843 54.6189C130.372 54.6189 119.371 59.1757 111.26 67.2867C103.149 75.3977 98.5927 86.3985 98.5927 97.8692C98.5927 109.34 103.149 120.341 111.26 128.452C119.371 136.563 130.372 141.119 141.843 141.119C153.314 141.119 164.315 136.563 172.426 128.452C180.537 120.341 185.093 109.34 185.093 97.8692C185.093 86.3985 180.537 75.3977 172.426 67.2867C164.315 59.1757 153.314 54.6189 141.843 54.6189ZM169.922 120.876L162.302 113.248C161.949 112.892 161.53 112.61 161.067 112.418C160.605 112.225 160.109 112.126 159.608 112.126C159.107 112.126 158.611 112.225 158.149 112.418C157.686 112.61 157.267 112.892 156.914 113.248C156.558 113.601 156.276 114.021 156.084 114.483C155.891 114.945 155.792 115.441 155.792 115.942C155.792 116.443 155.891 116.939 156.084 117.401C156.276 117.864 156.558 118.283 156.914 118.636L164.496 126.226C159.043 130.614 152.432 133.323 145.468 134.023V123.362C145.466 122.355 145.065 121.39 144.352 120.678C143.639 119.967 142.673 119.567 141.666 119.567C140.659 119.567 139.693 119.967 138.98 120.678C138.267 121.39 137.866 122.355 137.864 123.362V133.969C130.938 133.21 124.379 130.468 118.975 126.072L126.418 118.621C126.774 118.268 127.056 117.848 127.248 117.386C127.441 116.924 127.54 116.428 127.54 115.927C127.54 115.426 127.441 114.93 127.248 114.468C127.056 114.005 126.774 113.585 126.418 113.233C126.065 112.877 125.646 112.595 125.183 112.402C124.721 112.21 124.225 112.11 123.724 112.11C123.223 112.11 122.727 112.21 122.265 112.402C121.802 112.595 121.383 112.877 121.03 113.233L113.587 120.676C109.194 115.271 106.457 108.711 105.705 101.787H116.288C117.296 101.787 118.262 101.388 118.974 100.676C119.687 99.9647 120.089 98.9995 120.091 97.9924C120.091 97.493 119.993 96.9986 119.801 96.5372C119.61 96.0759 119.33 95.6568 118.977 95.3037C118.624 94.9506 118.205 94.6705 117.744 94.4794C117.282 94.2883 116.788 94.19 116.288 94.19H105.674C106.395 87.2335 109.117 80.6351 113.51 75.1934L121.076 82.7597C121.429 83.1153 121.849 83.3975 122.311 83.5902C122.773 83.7828 123.269 83.8819 123.77 83.8819C124.271 83.8819 124.767 83.7828 125.229 83.5902C125.692 83.3975 126.111 83.1153 126.464 82.7597C126.82 82.4069 127.102 81.9873 127.295 81.5249C127.487 81.0625 127.586 80.5666 127.586 80.0657C127.586 79.5648 127.487 79.0689 127.295 78.6065C127.102 78.1441 126.82 77.7245 126.464 77.3717L118.867 69.7669C124.298 65.2967 130.917 62.5116 137.91 61.7542V72.6687C137.912 73.6759 138.313 74.641 139.026 75.3525C139.739 76.0639 140.705 76.4634 141.712 76.4634C142.719 76.4634 143.685 76.0639 144.398 75.3525C145.111 74.641 145.513 73.6759 145.515 72.6687V61.7311C152.545 62.436 159.213 65.1871 164.696 69.6438L156.999 77.3871C156.643 77.7399 156.361 78.1595 156.168 78.6219C155.976 79.0843 155.876 79.5802 155.876 80.0811C155.876 80.582 155.976 81.0779 156.168 81.5403C156.361 82.0027 156.643 82.4223 156.999 82.7751C157.351 83.1307 157.771 83.413 158.234 83.6056C158.696 83.7982 159.192 83.8974 159.693 83.8974C160.194 83.8974 160.69 83.7982 161.152 83.6056C161.614 83.413 162.034 83.1307 162.387 82.7751L170.13 75.0318C174.563 80.5251 177.292 87.1954 177.981 94.2208H167.043C166.035 94.2208 165.068 94.6214 164.355 95.3345C163.642 96.0475 163.241 97.0147 163.241 98.0232C163.243 99.0303 163.645 99.9954 164.357 100.707C165.07 101.418 166.036 101.818 167.043 101.818H177.943C177.18 108.816 174.393 115.439 169.922 120.876Z",
    fill: "url(#paint10_linear_102_53)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_102_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.835 115.65C151.851 115.65 159.97 107.531 159.97 97.5151C159.97 87.4997 151.851 79.3806 141.835 79.3806C131.82 79.3806 123.701 87.4997 123.701 97.5151C123.701 107.531 131.82 115.65 141.835 115.65Z",
    fill: "url(#paint11_linear_102_53)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_102_53",
    x: 53.0179,
    y: 14.6862,
    width: 177.643,
    height: 165.743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53943
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_102_53"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_102_53",
    x: 89.9566,
    y: 45.9904,
    width: 103.758,
    height: 103.758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92429
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_53",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.769715
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_102_53"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_102_53",
    x: 95.5139,
    y: 51.5401,
    width: 92.6583,
    height: 92.6583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53943
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_102_53",
    x: 120.622,
    y: 76.3017,
    width: 42.4267,
    height: 42.4268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53943
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_102_53",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.628 200.688) rotate(90) scale(7.31229 141.628)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_53",
    x1: 191.166,
    y1: 202.173,
    x2: 191.166,
    y2: 192.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_53",
    x1: 90.911,
    y1: 202.173,
    x2: 90.911,
    y2: 192.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_102_53",
    x1: 49.0001,
    y1: 4.71835,
    x2: 235.841,
    y2: 191.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35ACE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B65B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_102_53",
    x1: 53.0179,
    y1: 97.5614,
    x2: 230.66,
    y2: 97.5614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C67B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_102_53",
    x1: 100.225,
    y1: 153.658,
    x2: 70.5751,
    y2: 153.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_102_53",
    x1: 183.877,
    y1: 153.658,
    x2: 212.549,
    y2: 153.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_102_53",
    x1: 56.9358,
    y1: 73.9619,
    x2: 52.3175,
    y2: 73.9619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_102_53",
    x1: 56.9358,
    y1: 121.169,
    x2: 52.3175,
    y2: 121.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_102_53",
    x1: 109.954,
    y1: 62.5008,
    x2: 173.117,
    y2: 132.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_102_53",
    x1: 113.133,
    y1: 66.0261,
    x2: 170.007,
    y2: 129.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_102_53",
    x1: 123.701,
    y1: 97.5151,
    x2: 159.977,
    y2: 97.5151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock1);
export default __webpack_public_path__ + "static/media/Lock1.8a251b8cf3ba827d5cbf42c1711d411f.svg";
export { ForwardRef as ReactComponent };